import React from "react";
import "./Features.css";

const features = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dlurlrbou/image/upload/v1753724415/feature3_f4hr1e.png",
    title: "Accuracy",
    description:
      "From banking to healthcare, our technology adapts to various industries.",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dlurlrbou/image/upload/v1753724392/feature2_bpb4rf.jpg",
    title: "Unmatched Security",
    description:
      "Protect your identity and assets with our state-of-the-art biometric security.",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/dlurlrbou/image/upload/v1753724396/newimage_dp179z.png",
    title: "Convience",
    description:
      "From banking to healthcare, our technology adapts to various industries.",
  },
];

export default function Feature() {
  return (
    <section
      className="feature-section"
      style={{
       backgroundImage: "url('/background.png')",
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
        color: "white",
      }}
    >
      <h2 className="feature-heading">
        Experience the Future of Security and Convenience
      </h2>
      <p className="feature-subheading">
        We offer unparalleled security through advanced palm recognition
        technology.
      </p>

      <div className="feature-grid">
        {features.map((item) => (
          <div key={item.id} className="feature-card">
            <img src={item.image} alt={item.title} className="feature-img" />
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
